import {DrawerProps} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {CustomerSubscription} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: CustomerSubscription,
        // Resolves true when the save landed. The drawer closes only then: a rejected
        // save keeps it open with the operator's values (§7). The payload is built from
        // the values in buildCustomerSubscriptionInput, never by mutating them here.
        handleSubmit: (values: CustomerSubscription) => Promise<boolean>
    }) => {

    const title = record?.id ? I18n.get('Edit Subscription') : I18n.get('Add Subscription');

    const handleFormSubmit = async (values: CustomerSubscription) => {
        const saved = await handleSubmit(values);
        if (saved) {
            onClose();
        }
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    );
};
